<template>
  <div v-if="!slides">
    <v-skeleton-loader
        type="image"
        :style="{ aspectRatio: $vuetify.breakpoint.mdAndUp ? 3 : $vuetify.breakpoint.sm ? 1.6:1 }"
        boilerplate
    ></v-skeleton-loader>
  </div>
  <v-carousel v-else :interval="time" cycle height="auto" hide-delimiter-background show-arrows-on-hover>
    <span v-if="lang == 'en'">
       <span v-if="$vuetify.breakpoint.smAndDown">
          <v-carousel-item v-for="(slide, i) in slides" :key="i" eager>
           <span>
            <v-row align="center" class="fill-height cursor-pointer" justify="center" >
<!--              <v-img-->
<!--                  :alt="slide.banner_th_url ? slide.banner_th_url : ''"-->
<!--                  :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 3 : $vuetify.breakpoint.sm ? 1.6:1"-->
<!--                  :src="url+slide.banner_mobile_en"-->
<!--                  @click="open_link(slide.banner_en_url);"-->
<!--              >-->
<!--                <template v-slot:placeholder>-->
<!--                  <v-sheet class="fill-height" color="#EFEFEF"></v-sheet>-->
<!--                </template>-->
<!--              </v-img>-->
                  <div
                      :style="{
                      position: 'relative',
                      width: '100%',
                      paddingTop: ($vuetify.breakpoint.mdAndUp ? (1/3)*100 : $vuetify.breakpoint.sm ? (1/1.6)*100 : 100) + '%',
                      background: '#EFEFEF'
                    }"
                  >
                      <img
                          :src="url + slide.banner_mobile_en"
                          :alt="slide.banner_th_url ? slide.banner_th_url : ''"
                          :fetchpriority="i === 0 ? 'high' : 'auto'"
                          :loading="i === 0 ? 'eager' : 'lazy'"
                          @click="open_link(slide.banner_en_url)"
                          class="banner-img"
                      />
                  </div>
            </v-row>
          </span>
      </v-carousel-item>
       </span>
       <span v-else>
          <v-carousel-item v-for="(slide, i) in slides" :key="i" eager>
              <v-row align="center" class="fill-height cursor-pointer" justify="center">
<!--                <v-img-->
<!--                    :alt="slide.banner_th_url ? slide.banner_th_url : ''"-->
<!--                    :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 3 : $vuetify.breakpoint.sm ? 1.6:1"-->
<!--                    :src="url+slide.banner_desktop_en"-->
<!--                    @click="open_link(slide.banner_en_url);"-->
<!--                >-->
<!--                   <template v-slot:placeholder>-->
<!--                      <v-sheet class="fill-height" color="#EFEFEF"></v-sheet>-->
<!--                   </template>-->
<!--                </v-img>-->
                  <div
                      :style="{
                      position: 'relative',
                      width: '100%',
                      paddingTop: ($vuetify.breakpoint.mdAndUp ? (1/3)*100 : $vuetify.breakpoint.sm ? (1/1.6)*100 : 100) + '%',
                      background: '#EFEFEF'
                    }"
                  >
                      <img
                          :src="url + slide.banner_desktop_en"
                          :alt="slide.banner_th_url ? slide.banner_th_url : ''"
                          :fetchpriority="i === 0 ? 'high' : 'auto'"
                          :loading="i === 0 ? 'eager' : 'lazy'"
                          @click="open_link(slide.banner_en_url)"
                          class="banner-img"
                      />
                  </div>
              </v-row>
         </v-carousel-item>
       </span>
    </span>
    <span v-else>
       <span v-if="$vuetify.breakpoint.smAndDown">
          <v-carousel-item v-for="(slide, i) in slides" :key="i" eager>
              <span>
                  <v-row align="center" class="fill-height cursor-pointer" justify="center" >
  <!--                  <v-img-->
  <!--                      :alt="slide.banner_th_url ? slide.banner_th_url : ''"-->
  <!--                      :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 3 : $vuetify.breakpoint.sm ? 1.6:1"-->
  <!--                      :src="url+slide.banner_mobile_th"-->
  <!--                      @click="open_link(slide.banner_th_url);"-->
  <!--                  >-->
  <!--                    <template v-slot:placeholder>-->
  <!--                      <v-sheet class="fill-height" color="#EFEFEF"></v-sheet>-->
  <!--                   </template>-->
  <!--                  </v-img>-->
                      <div
                          :style="{
                          position: 'relative',
                          width: '100%',
                          paddingTop: ($vuetify.breakpoint.mdAndUp ? (1/3)*100 : $vuetify.breakpoint.sm ? (1/1.6)*100 : 100) + '%',
                          background: '#EFEFEF'
                        }"
                      >
                          <img
                              :src="url + slide.banner_mobile_th"
                              :alt="slide.banner_th_url ? slide.banner_th_url : ''"
                              :fetchpriority="i === 0 ? 'high' : 'auto'"
                              :loading="i === 0 ? 'eager' : 'lazy'"
                              @click="open_link(slide.banner_th_url)"
                              class="banner-img"
                          />
                      </div>
                  </v-row>
              </span>
          </v-carousel-item>
       </span>
       <span v-else>
          <v-carousel-item v-for="(slide, i) in slides" :key="i" eager>
              <v-row align="center" class="fill-height cursor-pointer" justify="center" >
<!--                  <v-img-->
<!--                      :alt="slide.banner_th_url ? slide.banner_th_url : ''"-->
<!--                      :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 3 : $vuetify.breakpoint.sm ? 1.6:1"-->
<!--                      :src="url+slide.banner_desktop_th"-->
<!--                      @click="open_link(slide.banner_th_url);"-->
<!--                  >-->
<!--                      <template v-slot:placeholder>-->
<!--                          <v-sheet class="fill-height" color="#EFEFEF"></v-sheet>-->
<!--                      </template>-->
<!--                  </v-img>-->
                  <div
                      :style="{
                        position: 'relative',
                        width: '100%',
                        paddingTop: ($vuetify.breakpoint.mdAndUp ? (1/3)*100 : $vuetify.breakpoint.sm ? (1/1.6)*100 : 100) + '%',
                        background: '#EFEFEF'
                      }"
                  >
                      <img
                          :src="url + slide.banner_desktop_th"
                          :alt="slide.banner_th_url ? slide.banner_th_url : ''"
                          :fetchpriority="i === 0 ? 'high' : 'auto'"
                          :loading="i === 0 ? 'eager' : 'lazy'"
                          @click="open_link(slide.banner_th_url)"
                          class="banner-img"
                      />
                  </div>
              </v-row>
         </v-carousel-item>
       </span>
    </span>
  </v-carousel>
</template>

<script>
import { url } from "@/util/Constants";

export default {
  props: ['slides', 'lang'],
  data: () => ({
    url,
    time: 3000
  }),
  created() {
    // console.log("this.slides", this.slides)
    if (this.slides) {
      if (this.slides.time_effect) {
        this.time = parseInt(this.slides.time_effect) * 1000;

      }
    }
  },
  methods: {
    // openlink_th(index) {
    //   // alert(url + '/image/5f67662f4bc43802823220.png')
    //     alert("th")
    //   console.log(index)
    //   if (this.slides.banner_th_url){
    //   window.open( this.slides.banner_th_url)
    //   }
    // },
    // openlink_en(index) {
    //     alert("en")
    //   if (this.slides.banner_th_url){
    //     console.log(index)
    //     window.open(this.slides.banner_en_url)
    //   }
    //
    // }
    open_link(path){
      // console.log(path)
      window.open(path, '_blank');
    }
  }
};
</script>

<style>
.v-skeleton-loader__image {
  height: 100%;
}

.banner-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
</style>
